import { LIST_MENU } from "../actions/menu.actions";

const menuReducer = (state={}, action) => {
    switch(action.type){
        case LIST_MENU:
            return {
                ...state,
                listMenu: action.data
            }
        default:
            return state;
    }
}

export default menuReducer;